
import axios from 'axios'
import router from '@/router/index'
import baseurl from "@/utils/baseurl";
import { ElMessage } from 'element-plus'
var qs = require("qs");
// 域名地址
axios.defaults.baseURL = baseurl.baseurl;
//  REQUEST 请求异常拦截
axios.interceptors.request.use(config => {
  // console.log(config, 'config')
  // config.headers.Authorization= 'Bearer ' + window.localStorage.getItem('token'),
  config.headers.token=window.localStorage.getItem('token'),
  
  // config.headers = {
  //   //请求头自定义
  //   "Content-Type": "application/json",
  //   Authorization: 'Bearer ' + window.localStorage.getItem('token'),
  // };
  // if (config.url == '/customer/rx-study-member/studyMemberLoginCode') {
  //   config.headers = {
  //     //请求头自定义
  //     "Content-Type": "application/x-www-form-urlencoded",
  //   };
  //   config.data = qs.stringify(config.data) // 转为formdata数据格式
  // }

  config.timeout = 30000;
  return config;
}, err => {
  // 错误处理
  console.log('请求超时!')
  return Promise.resolve(err);
});
//  RESPONSE 响应异常拦截
axios.interceptors.response.use(result => {
  console.log(result, 'result')
  if (result.data.code == 401) {//登录失效，进入登录页
    // showFailToast('授权已过期')
    ElMessage.error('授权已过期,请重新登录');
    // 延迟 1 秒显示
    setTimeout(() => {
      window.localStorage.clear()
      location.reload();
      // window.location.href = '/index'
    }, 1000)

    return result.data;
  }

  // };

  return result.data;
},
  error => {
    if (error.response) {
      console.log("请求错误", error.response.status);
      switch (error.response.status) {
        case 401:
          window.localStorage.clear()
          // window.location.href = '/login'
          break;
        case 404:
          console.log('接口不存在');
          break;
        case 500:
          console.log('服务器错误');
          break;
        case 403:
          //   window.location.href = "/login";
          break;
        case 503:
          // window.localStorage.clear()
          // window.location.href = '/login'
          break;
      }
    }
    return Promise.reject(error); // 返回接口返回的错误信息
  });

// 接口域名
export const url = axios.defaults.baseURL;

// POST 方法封装 (处理参数与文件上传)
export const postRequest = (url, params, Contenttype="application/json") => {
  return axios({
    headers:{
      "Content-Type": Contenttype
    },
    method: 'post',
    url: url,
    // data: params,
    params: params
  });
}
// POST方法封装(视频链接)
export const postVideoRequest = (url, params, Contenttype="application/json") => {
  return axios({
    headers:{
      "Content-Type": Contenttype
    },
    method: 'post',
    url: url,
    params: params
  });
}
//POST方法封装（文件导出）
export const post = (url, params) => {
  return axios({
    method: 'post',
    url: url,
    data: params,
    responseType: 'arraybuffer',
    // params: params
  });
}

//  GET 方法封装
export const getRequest = (url, params) => {
  return axios({
    method: 'get',
    url: url,
    data: params,
    params: params
  });
}

//  PUT 方法封装
export const putRequest = (url, params) => {
  return axios({
    method: 'put',
    url: url,
    data: params,
  });
}

//  DELETE 方法封装
export const deleteRequest = (url, params) => {
  return axios({
    method: 'delete',
    url: url,
    data: params,
  });
}